import { useEffect, useState } from "react";
import { ICreateSalesData, ICustomer } from "../../@types";
import {
  InvoiceErrors,
  validateFreeFormItemDetails,
  validateInvoiceBasicInfo,
  validateInvoiceItemDetails,
  validateInvoiceSummary,
} from "../../modules/validateInvoiceForm";
import { useCompanyStore } from "../../state/useCompanyStore";
import { useSearchParams } from "react-router-dom";
import { useUserStore } from "../../state";
import { useGetPaymentCurrencyList } from "../../utils";

export const useFreeformInvoiceFormState = (initialData?: ICreateSalesData) => {
  const { company: user } = useCompanyStore();
  const { userCurrencyCode } = useGetPaymentCurrencyList(user);
  const initialFormData: ICreateSalesData = {
    additionalInformation: "",
    customerId: "",
    description: "",
    currency: userCurrencyCode?.currency ?? "NGN",
    discount: 0,
    inventories: [{ id: "", name: "", amount: 0, quantity: 0, rate: 0 }],
    services: [{ id: "", name: "", duration: "", price: 0 }],
    invoiceDueAt: "",
    invoiceNumber: "",
    issueDate: new Date().toISOString().substring(0, 10),
    isReoccurring: false,
    isReoccurringEndDate: "",
    isReoccurringStartDate: "",
    reoccurringGroupName: "",
    status: "pending",
    tax: 0,
    isPaymentCompleted: false,
    shouldSendEmail: true,
    exchangeRate: 1,
    paymentMethod: "",
    lineItems: [],
    invoiceType: "freeform",
    logoBase64: user?.logoBase64 || user?.logoUrl,
    //   reminderSettings: [
    //     { days: 0, remindBy: "before", remindMe: false, isActive: false },
    //     { days: 0, remindBy: "due", remindMe: false, isActive: false },
    //     { days: 0, remindBy: "after", remindMe: false, isActive: false },
    //   ],
  };
  const companyStore = useCompanyStore();
  const isRetail = companyStore.isRetailBusiness();

  const [formData, setFormData] = useState<ICreateSalesData>(
    initialData || initialFormData,
  );
  const [validationResults, setValidationResults] = useState<InvoiceErrors>({});
  const [customer, setCustomer] = useState<ICustomer | null>(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isDraftLoading, setIsDraftLoading] = useState(false);
  const [showSidebar, setShowSidebar] = useState(false);

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    setFormData((prev: any) => ({ ...prev, [name]: value }));
    //@ts-ignore
    if (validationResults[name]) {
      setValidationResults((prev: any) => ({ ...prev, [name]: undefined }));
    }
  };

  const handleSetCustomer = (selectedCustomer: ICustomer | null) => {
    setCustomer(selectedCustomer || null);
    setFormData((prev: any) => ({
      ...prev,
      customerId: selectedCustomer?.id || "",
    }));
  };
  const [searchParams] = useSearchParams();
  useEffect(() => {
    const customerId = searchParams.get("customerId");
    const customerName = searchParams.get("customerName");
    const customerPhone = searchParams.get("customerPhone");
    const invoiceType = searchParams.get("invoiceType");

    if (customerId && customerName && customerPhone && invoiceType) {
      setCustomer({ id: customerId, name: customerName, phone: customerPhone });
      handleSetCustomer({
        id: customerId,
        name: customerName,
        phone: customerPhone,
      });
    }
  }, [searchParams]);

  const validateForm = () => {
    const basicInfoValid = validateInvoiceBasicInfo(
      formData,
      setValidationResults,
    );
    // const itemDetailsValid = validateInvoiceItemDetails (
    //   formData,
    //   setValidationResults,
    //   isRetail
    // );
    const summaryValid = validateInvoiceSummary(formData, setValidationResults);
    return basicInfoValid && summaryValid;
  };

  const resetForm = () => {
    setFormData(initialFormData);
    setValidationResults({});
    setCustomer(null);
  };

  return {
    formData,
    setFormData,
    customer,
    handleSetCustomer,
    validationResults,
    setValidationResults,
    errorMessage,
    setErrorMessage,
    isLoading,
    setIsLoading,
    isDraftLoading,
    setIsDraftLoading,
    showSidebar,
    setShowSidebar,
    handleInputChange,
    validateForm,
    resetForm,
    isRetail,
  };
};
